import { createFileRoute } from '@tanstack/react-router'
import { HelpIndexScreen } from '../../features/help/screens'
import { helpGuidesQuery } from '../../features/help/use-help'
import { helpViewerQuery } from '../../features/help/viewer'

/** /help: the index and search. Public; what it lists depends on the viewer. Owner: slice 36 `web-help-centre`. */
export const Route = createFileRoute('/help/')({
  loader: async ({ context }) => {
    const viewer = await context.queryClient.ensureQueryData(helpViewerQuery())
    await context.queryClient.ensureQueryData(helpGuidesQuery(viewer))
  },
  component: HelpIndexScreen,
})
